@if (isDesktopView) {
  <tf-settings-list-header
    [showSearch]="false"
    [loading]="isLoading()"
    [refreshTooltip]="'SETTINGS_AUDIT_LOG.RELOAD_AUDIT_LOGS' | translate"
    (refresh)="reloadAuditLogs.emit()">
    <div headerStart class="filters-row">
      <div class="filter-group">
        <div class="filter-field">
          <label for="from-date-desktop">
            {{ 'SETTINGS_AUDIT_LOG.FILTERS.FROM_DATE' | translate }}
          </label>
          <p-datepicker
            inputId="from-date-desktop"
            [ngModel]="localFromDate()"
            (ngModelChange)="onFromDateChange($event)"
            dateFormat="yy-mm-dd"
            [showIcon]="true"
            [maxDate]="localToDate() || undefined"
            [placeholder]="'SETTINGS_AUDIT_LOG.FILTERS.SELECT_START_DATE' | translate"
            styleClass="filter-input" />
        </div>

        <div class="filter-field">
          <label for="to-date-desktop">
            {{ 'SETTINGS_AUDIT_LOG.FILTERS.TO_DATE' | translate }}
          </label>
          <p-datepicker
            inputId="to-date-desktop"
            [ngModel]="localToDate()"
            (ngModelChange)="onToDateChange($event)"
            dateFormat="yy-mm-dd"
            [showIcon]="true"
            [minDate]="localFromDate() || undefined"
            [placeholder]="'SETTINGS_AUDIT_LOG.FILTERS.SELECT_END_DATE' | translate"
            styleClass="filter-input" />
        </div>
      </div>

      <div class="filter-group">
        <div class="filter-field">
          <label for="event-type-desktop">
            {{ 'SETTINGS_AUDIT_LOG.FILTERS.EVENT_TYPE' | translate }}
          </label>
          <p-select
            inputId="event-type-desktop"
            [ngModel]="localEventType()"
            (ngModelChange)="onEventTypeChange($event)"
            [options]="eventTypeOptions"
            [placeholder]="'SETTINGS_AUDIT_LOG.FILTERS.SELECT_EVENT_TYPE' | translate"
            [showClear]="true"
            class="filter-input" />
        </div>

        <div class="filter-field">
          <label for="scope-type-desktop">
            {{ 'SETTINGS_AUDIT_LOG.FILTERS.SCOPE_TYPE' | translate }}
          </label>
          <p-select
            inputId="scope-type-desktop"
            [ngModel]="localScopeType()"
            (ngModelChange)="onScopeTypeChange($event)"
            [options]="scopeTypeOptions"
            [placeholder]="'SETTINGS_AUDIT_LOG.FILTERS.SELECT_SCOPE_TYPE' | translate"
            [showClear]="true"
            class="filter-input" />
        </div>
      </div>

      <div class="filter-group">
        <div class="filter-field">
          <label for="scope-id-desktop">
            {{ 'SETTINGS_AUDIT_LOG.FILTERS.SCOPE_ID' | translate }}
          </label>
          <input
            pInputText
            id="scope-id-desktop"
            type="text"
            [ngModel]="localScopeId()"
            (ngModelChange)="onScopeIdChange($event)"
            [placeholder]="'SETTINGS_AUDIT_LOG.FILTERS.SELECT_SCOPE_ID' | translate"
            class="filter-input" />
        </div>

        <div class="filter-field">
          <label for="actor-id-desktop">
            {{ 'SETTINGS_AUDIT_LOG.FILTERS.ACTOR_ID' | translate }}
          </label>
          <input
            pInputText
            id="actor-id-desktop"
            type="text"
            [ngModel]="localActorId()"
            (ngModelChange)="onActorIdChange($event)"
            [placeholder]="'SETTINGS_AUDIT_LOG.FILTERS.SELECT_ACTOR_ID' | translate"
            class="filter-input" />
        </div>
      </div>
    </div>
    <p-button
      headerActions
      [label]="'GENERAL.APPLY' | translate"
      severity="primary"
      (onClick)="applyFilters()" />
    <p-button
      headerActions
      [label]="'GENERAL.CLEAR' | translate"
      severity="secondary"
      (onClick)="clearFilters()" />
  </tf-settings-list-header>
}
@if (isTabletView) {
  <tf-settings-list-header
    [showSearch]="false"
    [loading]="isLoading()"
    [refreshTooltip]="'SETTINGS_AUDIT_LOG.RELOAD_AUDIT_LOGS' | translate"
    (refresh)="reloadAuditLogs.emit()">
    <p-button
      headerActions
      [label]="'SETTINGS_AUDIT_LOG.FILTERS.FILTERS' | translate"
      icon="pi pi-filter"
      [severity]="hasActiveFilters() ? 'primary' : 'secondary'"
      [outlined]="!hasActiveFilters()"
      (onClick)="toggleFilterPopover($event)" />
    @if (hasActiveFilters()) {
      <p-button
        headerActions
        [label]="'SETTINGS_AUDIT_LOG.FILTERS.CLEAR_FILTERS' | translate"
        icon="pi pi-filter-slash"
        severity="secondary"
        (onClick)="clearFilters()" />
    }
  </tf-settings-list-header>

  <p-popover #filterPopover styleClass="audit-log-filter-popover" [focusOnShow]="false">
    <div class="filter-content">
      <div class="filter-section">
        <div class="filter-field">
          <label for="from-date-tablet">
            {{ 'SETTINGS_AUDIT_LOG.FILTERS.FROM_DATE' | translate }}
          </label>
          <p-datepicker
            inputId="from-date-tablet"
            [ngModel]="localFromDate()"
            (ngModelChange)="onFromDateChange($event)"
            dateFormat="yy-mm-dd"
            [showIcon]="true"
            [maxDate]="localToDate() || undefined"
            [placeholder]="'SETTINGS_AUDIT_LOG.FILTERS.SELECT_START_DATE' | translate"
            styleClass="filter-input" />
        </div>

        <div class="filter-field">
          <label for="to-date-tablet">{{ 'SETTINGS_AUDIT_LOG.FILTERS.TO_DATE' | translate }}</label>
          <p-datepicker
            inputId="to-date-tablet"
            [ngModel]="localToDate()"
            (ngModelChange)="onToDateChange($event)"
            dateFormat="yy-mm-dd"
            [showIcon]="true"
            [minDate]="localFromDate() || undefined"
            [placeholder]="'SETTINGS_AUDIT_LOG.FILTERS.SELECT_END_DATE' | translate"
            styleClass="filter-input" />
        </div>
      </div>

      <div class="filter-section">
        <div class="filter-field">
          <label for="event-type-tablet">
            {{ 'SETTINGS_AUDIT_LOG.FILTERS.EVENT_TYPE' | translate }}
          </label>
          <p-select
            inputId="event-type-tablet"
            [ngModel]="localEventType()"
            (ngModelChange)="onEventTypeChange($event)"
            [options]="eventTypeOptions"
            [placeholder]="'SETTINGS_AUDIT_LOG.FILTERS.SELECT_EVENT_TYPE' | translate"
            [showClear]="true"
            class="filter-input" />
        </div>

        <div class="filter-field">
          <label for="scope-type-tablet">
            {{ 'SETTINGS_AUDIT_LOG.FILTERS.SCOPE_TYPE' | translate }}
          </label>
          <p-select
            inputId="scope-type-tablet"
            [ngModel]="localScopeType()"
            (ngModelChange)="onScopeTypeChange($event)"
            [options]="scopeTypeOptions"
            [placeholder]="'SETTINGS_AUDIT_LOG.FILTERS.SELECT_SCOPE_TYPE' | translate"
            [showClear]="true"
            class="filter-input" />
        </div>

        <div class="filter-field">
          <label for="scope-id-tablet">
            {{ 'SETTINGS_AUDIT_LOG.FILTERS.SCOPE_ID' | translate }}
          </label>
          <input
            pInputText
            id="scope-id-tablet"
            type="text"
            [ngModel]="localScopeId()"
            (ngModelChange)="onScopeIdChange($event)"
            [placeholder]="'SETTINGS_AUDIT_LOG.FILTERS.SELECT_SCOPE_ID' | translate"
            class="filter-input" />
        </div>

        <div class="filter-field">
          <label for="actor-id-tablet">
            {{ 'SETTINGS_AUDIT_LOG.FILTERS.ACTOR_ID' | translate }}
          </label>
          <input
            pInputText
            id="actor-id-tablet"
            type="text"
            [ngModel]="localActorId()"
            (ngModelChange)="onActorIdChange($event)"
            [placeholder]="'SETTINGS_AUDIT_LOG.FILTERS.SELECT_ACTOR_ID' | translate"
            class="filter-input" />
        </div>
      </div>

      <div class="filter-actions">
        <p-button
          [label]="'GENERAL.APPLY' | translate"
          severity="primary"
          class="w-full"
          (onClick)="applyFilters()" />
        <p-button
          [label]="'GENERAL.CLEAR' | translate"
          severity="secondary"
          class="w-full"
          (onClick)="clearFilters()" />
      </div>
    </div>
  </p-popover>
}
